import ApplicationLogo from "components/ApplicationLogo";
// import Dropdown from 'components/Dropdown'
import Dropdown from "react-bootstrap/Dropdown";
import Link from "components/Link";
import $ from "jquery";
import Input from "components/Input";
import NavLink from "components/NavLink";
import ResponsiveNavLink, {
  ResponsiveNavButton,
} from "components/ResponsiveNavLink";
import { DropdownButton } from "components/DropdownLink";
import { useAuth } from "hooks/auth";
import { useState, useRef, useEffect } from "react";
import BtnIcon from "components/BtnIcon";
import IconApp from "components/IconApp";
import Configs from "../Configs";
// import { fontMontserrat } from '../layout'
import { checkNotAuthorized, getStorage } from "../Utils";
import { api_services } from "hooks/api_services";
import { useSelector, useDispatch } from "react-redux";
import { VAR_SET_NAME, VAR_SET_TOTAL_EWS } from "hooks/redux";
import { usePathname, useRouter } from "components/Navigation";
import TooltipsApp from "components/TooltipsApp";
import {
  handleget_headers_params,
  initFilterUrlLikelihood,
  initFilterUrl,
  showToastr,
  clearStorage,
} from "pages/Utils";
import { useNavigate } from "react-router";

const Navigation = ({ user }) => {
  const navigate = useNavigate();
  const input_search_global = useRef();
  // const { akses_application } = JSON.parse(getStorage("user_login"));
  const userLogin = JSON.parse(getStorage("user_login")) || {};
  const { akses_application } = userLogin;
  const { logout } = useAuth();

  const { getapi_services, postapi_services, deleteapi_services } =
    api_services({});
  const router = useRouter();
  const pathname = usePathname();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [search_open, setsearch_open] = useState(false);
  const [nama_group, setnama_group] = useState("");
  const [is_arr_group, setis_arr_group] = useState(false);
  const [dropdown, setdropdown] = useState([]);
  const [keyword, setkeyword] = useState("");
  const [count_notif, setcount_notif] = useState(0);
  const delay = 5;

  const name = useSelector((state) => state.name);
  const { change_app } = useAuth({});
  const [count_ews, setcount_ews] = useState("");
  const timer = useRef(null);
  const initialized = useRef(false);
  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      initUserLogin();
    }
  }, []);

  useEffect(() => {
    handlegetnotifikasi();
    timer.current = setInterval(() => handlegetnotifikasi(), delay * 1000);
    return () => {
      clearInterval(timer.current);
    };
  }, []);

  const sidebarExpandCollapse = () => {
    // console.log("x")
    $("body").toggleClass("sidebar-collapsed");
  };

  const handleExpandCollapseSearch = () => {
    setsearch_open(!search_open);

    let is_focus = search_open === true ? false : true;
    if (is_focus) {
      input_search_global.current.focus();
    }
  };

  const initUserLogin = async () => {
    const userLoginObj = await getStorage("user_login");
    const user_login = JSON.parse(userLoginObj);

    const is_arr_groupObj = await getStorage("is_arr_group");
    const is_arr_group = JSON.parse(is_arr_groupObj);

    // console.log('is_arr_group')
    // console.log(is_arr_group)

    setnama_group(user_login.nama_group ? user_login.nama_group : "");
    setis_arr_group(is_arr_group == 1 ? true : false);

    dispatch({
      type: VAR_SET_NAME,
      value: user_login.user.name,
    });
  };

  const handlegetnotifikasi = async () => {
    const response = await getapi_services({
      api_path: "/notifikasi",
      filter: {
        paginate: {
          page: 1,
          pagesize: 1000,
        },
      },
    });
    // console.log('getmt_risk_tingkat_agregasi_risiko')
    // console.log(response)

    checkNotAuthorized(response);
    if (response.error) return;

    // let count_notif = 0
    // response.data.map(m => {
    //     if (m.is_read == 0) {
    //         count_notif += 1
    //     }
    // })
    setcount_notif(response.total_task);
    setdropdown(response);
    setcount_ews(response.total_ews);

    dispatch({
      type: VAR_SET_TOTAL_EWS,
      value: response.total_ews,
    });
  };

  // const handlegetnotifikasi_interval = setInterval(handlegetnotifikasi, 5000)

  const handlereadnotifikasi = async (id) => {
    const response = await postapi_services({
      api_path: `/readnotif/${id}`,
      disabledAlert: true,
    });
    // console.log('getmt_risk_tingkat_agregasi_risiko')
    // console.log(response)

    checkNotAuthorized(response);
    if (response.error) return;
    handlegetnotifikasi();
  };

  // const handleSearch = () => {
  //   router.push(`/search/${keyword}`);
  // };
  const handleSearch = (e) => {
    if (e) {
      e.preventDefault();
    }
    const trimmedKeyword = keyword.trim();
    if (trimmedKeyword) {
      // Gunakan query parameter untuk menghindari masalah dengan spasi dan karakter khusus
      const encodedKeyword = encodeURIComponent(trimmedKeyword);
      const searchUrl = `/search?q=${encodedKeyword}`;
      // Gunakan navigate langsung untuk memastikan query parameter terkirim
      navigate(searchUrl);
    } else {
      // Jika keyword kosong, tetap redirect ke /search
      navigate("/search");
    }
  };

  const handleChangeApp = async (idUser, idGroup, idApplication, idJabatan) => {
    const body = {
      id_group: idGroup,
      id_user: idUser,
      id_application: idApplication,
      id_jabatan: idJabatan,
    };
    const response = await change_app({
      ...body,
    });

    if (response.user) {
      if (idApplication == 3) {
        window.open(
          import.meta.env.VITE_URL_USER_AUDIT + `/login?user=${response.user}`,
          "_blank"
        );
      } else {
        window.open(
          import.meta.env.VITE_URL_USER_MANAGEMENT +
            `/login?user=${response.user}`,
          "_blank"
        );
      }
    }
    if (response.code || response.error) return;
  };

  return (
    <nav className="bg-white border-gray-100 navbar-app">
      <div className=" mx-auto px-0 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex">
            <div
              className="hidden sm:flex sm:items-center profile-user-login"
              style={{ backgroundColor: "#ffffffff" }}
            >
              {/* <div className="flex-1 container-top-user-login ps-3">
                <Link
                  href="/dashboard"
                  className="flex items-center"
                  style={{ marginLeft: 10 }}
                  // style=" margin-left: 10px"
                >
                  <ApplicationLogo
                    height={15}
                    width={15}
                    className="block h-10 w-auto fill-current text-gray-600"
                    src="/teks-biru.png"
                  />
                  <div className="title-logo" style={{ Color: "#ffff" }}></div>
                  <div className={`company-name ml-3`}>MANRISK</div>
                </Link>
              </div> */}
              <div className="flex-1 container-top-user-login ps-3">
                <Link href="/dashboard" className="logo-wrapper">
                  <img src="/perisai.png" alt="Company Icon" />
                </Link>
              </div>
              <div className="flex-1 container-teks-biru ps-3">
                <Link href="/dashboard" className="logo-wrapper">
                  <img src="/teks-biru.png" alt="Manrisk" />
                </Link>
              </div>

              <BtnIcon
                onTap={sidebarExpandCollapse}
                icon="menu"
                color="#000000ff"
              />
            </div>

            {/* <div className="flex-shrink-0 flex items-center navbar-logo">
              <Link href="/dashboard" className="flex items-center">
                <ApplicationLogo
                  height={50}
                  width={50}
                  className="block h-10 w-auto fill-current text-gray-600"
                />
                <div className={`company-name ml-3`}>
                  {Configs.applicationName}
                </div>
              </Link>
            </div> */}

            <div className="hidden space-x-2 sm:-my-px sm:ml-10 sm:flex navbar-icons">
              <BtnIcon
                onTap={handleExpandCollapseSearch}
                icon="search"
                style={{ height: 65, marginTop: "-5px" }}
              />
              <TooltipsApp
                title={"Aplikasi Lain"}
                id={"aplikasi_lain"}
                children={
                  <BtnIcon
                    icon="apps"
                    style={{ height: 65, marginTop: "-5px" }}
                    is_dropdown_aplikasi
                    data_aplikasi={akses_application}
                    onClickGroup={(m) => {
                      if (
                        // m.id_group &&
                        m.id_application
                        // &&
                        // m.id_user
                        //  &&
                        // m.id_application &&
                        // m.id_jabatan
                      ) {
                        handleChangeApp(
                          m.id_user,
                          m.id_group,
                          m.id_application,
                          m.id_jabatan
                        );
                      } else {
                        showToastr(
                          "error",
                          "Aplikasi tidak ditemukan, silahkan hubungi admin!"
                        );
                      }
                    }}
                    // notif={count_notif}
                    // onRead={handlereadnotifikasi}
                    dropdown={dropdown}
                  />
                }
                placement={"left"}
              />
              <div className="btn-icons relative my-auto">
                {count_ews ? (
                  <div className="item-count-notif">{count_ews}</div>
                ) : (
                  ""
                )}
                <TooltipsApp
                  title={"Early Warning System"}
                  id={"ews"}
                  children={
                    <Link className="material-icons" href="/risk_msg">
                      report_problem
                    </Link>
                  }
                  placement={"left"}
                />
              </div>
              <BtnIcon
                icon="flag"
                notif={count_notif}
                onRead={handlereadnotifikasi}
                dropdown={dropdown}
              />
            </div>
          </div>
          <div className="d-flex align-items-center">
            <Dropdown>
              <Dropdown.Toggle
                variant=""
                id="dropdown-basic"
                className="dropdown-toggle-profile"
              >
                <div className="d-flex align-items-center">
                  <div className="container-name-user-login">
                    <div className="profile-user-login-name">{user?.name}</div>
                    {/* <div className="profile-user-login-name">{name}</div> */}
                    <div className="profile-user-login-desc">{nama_group}</div>
                  </div>
                  <div className="icon-logo-profile">
                    <span className="material-icons material-icons-person">
                      person
                    </span>
                  </div>
                </div>
              </Dropdown.Toggle>

              <Dropdown.Menu className="dropdown-user-profile-topbar">
                {/* 
                    <Link
                      href={`/profile/detail`}
                      className="d-flex align-items-center link-edit"
                    >
                      <span
                        className="material-icons"
                        style={{ fontSize: 18, marginRight: 7 }}
                      >
                        person
                      </span>{" "}
                      Profile
                    </Link> */}

                <Dropdown.Item
                  onClick={() => {
                    router.push(`/profile/detail`);
                  }}
                  className="d-flex align-items-center"
                >
                  <span
                    className="material-icons"
                    style={{ fontSize: 18, marginRight: 7 }}
                  >
                    person
                  </span>
                  Profile
                </Dropdown.Item>

                {is_arr_group ? (
                  <>
                    <Link
                      href={`/akses`}
                      className="d-flex align-items-center link-edit"
                    >
                      <span
                        className="material-icons"
                        style={{ fontSize: 18, marginRight: 7 }}
                      >
                        person
                      </span>{" "}
                      Login Role
                    </Link>
                  </>
                ) : null}

                <Dropdown.Item
                  onClick={logout}
                  className="d-flex align-items-center"
                >
                  <span
                    className="material-icons"
                    style={{ fontSize: 18, marginRight: 7 }}
                  >
                    logout
                  </span>
                  Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>

          <div className="-mr-2 flex items-center sm:hidden navbar-right">
            <button
              onClick={() => setOpen((open) => !open)}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500 transition duration-150 ease-in-out"
            >
              <svg
                className="h-6 w-6"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24"
              >
                {open ? (
                  <path
                    className="inline-flex"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    className="inline-flex"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="block sm:hidden sidebar-mobile">
          <div className="pt-2 pb-3 space-y-1">
            {/* <ResponsiveNavLink
                            href="/dashboard"
                            active={usePathname() === '/dashboard'}>
                            Dashboard
                        </ResponsiveNavLink> */}

            <ul className="sidebar-ul">{/* {renderMenu(data_menu)} */}</ul>
          </div>

          <div className="pt-4 pb-1 border-t border-gray-200">
            <div className="flex items-center px-4">
              <div className="flex-shrink-0">
                <svg
                  className="h-10 w-10 fill-current text-gray-400"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                  />
                </svg>
              </div>

              <div className="ml-3">
                <div className="font-medium text-base text-gray-800">
                  {user?.name}
                </div>
                <div className="font-medium text-sm text-gray-500">
                  {user?.email}
                </div>
              </div>
            </div>

            <div className="mt-3 space-y-1">
              <ResponsiveNavButton onClick={logout}>Logout</ResponsiveNavButton>
            </div>
          </div>
        </div>
      )}

      <div className={`navbar-search ${search_open ? "active" : ""}`}>
        <div className="flex-1 flex align-items-center">
          <IconApp icon="search" />
          <form className="flex-1" onSubmit={handleSearch}>
            <div className="flex-1">
              <input
                ref={input_search_global}
                id="search_global"
                type="text"
                placeholder="Cari Risiko..."
                value={keyword}
                className="block mt-1 w-full"
                onChange={(event) => {
                  setkeyword(event.target.value);
                }}
                required
                autoFocus
              />
            </div>
          </form>
        </div>

        <BtnIcon onTap={handleExpandCollapseSearch} icon="close" />
      </div>
    </nav>
  );
};

export default Navigation;

{
  /* <nav className="bg-white border-b border-gray-100">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
            <div className="flex">

                <div className="flex-shrink-0 flex items-center">
                    <Link href="/dashboard">
                        <ApplicationLogo className="block h-10 w-auto fill-current text-gray-600" />
                    </Link>
                </div>

    
                <div className="hidden space-x-8 sm:-my-px sm:ml-10 sm:flex">
                    <NavLink
                        href="/dashboard"
                        active={usePathname() === '/dashboard'}>
                        Dashboard
                    </NavLink>
                </div>
            </div>

    
            <div className="hidden sm:flex sm:items-center sm:ml-6">
                <Dropdown
                    align="right"
                    width="48"
                    trigger={
                        <button className="flex items-center text-sm font-medium text-gray-500 hover:text-gray-700 focus:outline-none transition duration-150 ease-in-out">
                            <div>{user?.name}</div>

                            <div className="ml-1">
                                <svg
                                    className="fill-current h-4 w-4"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20">
                                    <path
                                        fillRule="evenodd"
                                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                        clipRule="evenodd"
                                    />
                                </svg>
                            </div>
                        </button>
                    }>

                    <DropdownButton onClick={logout}>
                        Logout
                    </DropdownButton>
                </Dropdown>
            </div>


            <div className="-mr-2 flex items-center sm:hidden">
                <button
                    onClick={() => setOpen(open => !open)}
                    className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500 transition duration-150 ease-in-out">
                    <svg
                        className="h-6 w-6"
                        stroke="currentColor"
                        fill="none"
                        viewBox="0 0 24 24">
                        {open ? (
                            <path
                                className="inline-flex"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M6 18L18 6M6 6l12 12"
                            />
                        ) : (
                            <path
                                className="inline-flex"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M4 6h16M4 12h16M4 18h16"
                            />
                        )}
                    </svg>
                </button>
            </div>
        </div>
    </div>


    {open && (
        <div className="block sm:hidden">
            <div className="pt-2 pb-3 space-y-1">
                <ResponsiveNavLink
                    href="/dashboard"
                    active={usePathname() === '/dashboard'}>
                    Dashboard
                </ResponsiveNavLink>
            </div>

            <div className="pt-4 pb-1 border-t border-gray-200">
                <div className="flex items-center px-4">
                    <div className="flex-shrink-0">
                        <svg
                            className="h-10 w-10 fill-current text-gray-400"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                            />
                        </svg>
                    </div>

                    <div className="ml-3">
                        <div className="font-medium text-base text-gray-800">
                            {user?.name}
                        </div>
                        <div className="font-medium text-sm text-gray-500">
                            {user?.email}
                        </div>
                    </div>
                </div>

                <div className="mt-3 space-y-1">
            
                    <ResponsiveNavButton onClick={logout}>
                        Logout
                    </ResponsiveNavButton>
                </div>
            </div>
        </div>
    )}
</nav> */
}
